import React from 'react';
import Card from 'react-bootstrap/Card';
import {
  FormField,
  InputText,
  Label,
  Row,
} from '../../common/form';
import Header from './header';
import Pane from './pane';
import FundContext from './context';

export default function DpFundPerformance() {
  const { state } = React.useContext(FundContext);
  const { fund: { dpPerformance } } = state;

  const event = 'dpPerformance';

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Performance from Data Provider</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          {dpPerformance.map(attribute => (
            <Row key={`dp-performance-${attribute.name}`}>
              <Label htmlFor={`dp-performance-${attribute.name}`}>{attribute.label}</Label>
              <FormField>
                <InputText
                  id={`dp-performance-attribute-${attribute.name}`}
                  type="text"
                  name={`dpPerformanceAttribute${attribute.name}`}
                  value={attribute.value}
                  disabled
                />
              </FormField>
            </Row>
          ))}
        </Card.Body>
      </Pane>
    </Card>
  );
}
